const sizes = {
  '-1': '0.8rem',
  0: '0.9rem',
  1: '1rem',
  2: '1.1rem',
  3: '1.2rem',
  4: '1.3rem',
  5: '1.7rem',
  6: '2rem',
  7: '2.25rem',
  8: '2.5rem',
  9: '2.7rem',
  10: '3rem',
};

export const getFontSize = (size) => {
  if (typeof size === 'number' && size >= 0 && size <= 10) {
    return `font-size: ${sizes[size]};`;
  }

  console.warn(`Invalid font size: ${size}. Returning default size.`);
  return `font-size: ${sizes[3]};`; // Default to '1.2rem'
};
